import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { createAccount, createSession, login, selectGuardian } from '../services/api';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { ageBandFromAge } from '../utils/ageBand';

/**
 * 快速体验入口(/quick):跳过选年龄、选蛋、起名,直接进六艺书院。
 *
 * 给大人验证功能用,孩子正常从首页进,看不到这个入口。
 * 默认登录同一个体验账号(没有就先建),所以进度会累积;
 * 想要一个全新的进度就换个名字:/quick?name=体验2
 */
export const QUICK_DEFAULTS = {
  name: '体验员',
  secret: '1234',
  age: 12,
  species: 'monkey',
  guardianName: '小悟',
};

function QuickStartPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [, setQuestState] = useLocalStorage('huaxia_quest_state', null);
  const [error, setError] = useState('');

  useEffect(() => {
    const name = (params.get('name') || QUICK_DEFAULTS.name).trim();
    const { secret } = QUICK_DEFAULTS;

    const enter = (r) => {
      setQuestState({
        sessionId: r.sessionId,
        guardian: r.guardian,
        masteries: r.masteries,
        ageBand: ageBandFromAge(r.age ?? QUICK_DEFAULTS.age),
        ownerName: r.ownerName,
      });
      navigate('/map', { replace: true });
    };

    (async () => {
      try {
        enter(await login(name, secret));
        return;
      } catch (err) {
        if (err?.response?.status !== 401) throw err;
      }
      // 第一次用:建一个存档并起好名字
      const session = await createSession(QUICK_DEFAULTS.age);
      await selectGuardian(session.sessionId, QUICK_DEFAULTS.species);
      await createAccount(session.sessionId, {
        username: name,
        password: secret,
        guardianName: QUICK_DEFAULTS.guardianName,
      });
      enter(await login(name, secret));
    })().catch((err) => {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : '体验账号没准备好,刷新再试试');
    });
    // eslint-disable-next-line
  }, []);

  return (
    <p className="p-10 text-center text-gray-500" role={error ? 'alert' : undefined}>
      {error || '正在进入六艺书院……'}
    </p>
  );
}

export default QuickStartPage;
